import React from 'react';
import { IconProps } from './model/IconInterface';

const AppleIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor', fill }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? color : 'none'}
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M12 7.5c-1.2-1.8-3.9-2.4-5.8-.9C4.1 8.3 3.6 11.2 4.5 14c1 3.2 3.2 6.5 5.3 6.5.9 0 1.4-.5 2.2-.5s1.3.5 2.2.5c2.1 0 4.3-3.3 5.3-6.5.9-2.8.4-5.7-1.7-7.4-1.9-1.5-4.6-.9-5.8.9z" /><path d="M12 7.5c0-2.2 1.3-3.7 3-4.5" />
    </svg>
  );
};

export default AppleIcon;
